import { Card } from 'components/Core/Card/Card'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const AllCalculators = () => {
    const navigate = useNavigate();
    return (
        <div>
            <Card id="trade-calculator" onClick={() => navigate('/calculate/trade?toProduct=BTC&fromProduct=ZAR')}
                style={{ width: 'fit-content', margin: 'auto', backgroundColor: '#fff', color: '#333' }}>
                <div style={{ width: '20rem', padding: '2rem' }}>
                    Trade calculator
                </div>
            </Card>

            <br />

            <Card id="vault-calculator"onClick={() => navigate('/calculate/vault?productCode=ETH&periodInDays=360&amount=100&recurring=true&frequency=monthly')}
                style={{ width: 'fit-content', margin: 'auto', backgroundColor: '#fff', color: '#333' }}>
                <div style={{ width: '20rem', padding: '2rem'}}>
                    Vault calculator
                </div>
            </Card>
        </div>
    )
}